import clientApi from '@/api/client';

const state = {
    listAllClient: null,
    listClient: null,
    client: null,
    clientCreated: null,
    clientUpdated: null,
    card: null,
    cardCreated: null,
    cardUpdated: null,
    cardUnlocked: null,
    cardBlocked: null,
    cardDeleted: null,
    isLoading: false,
    validationErrors: null,
    isSubmitting: false,
    listStatus: null,
    freezeList: null,
    packList: null,
    membershipList: null,
    buyList: null,
    scheduleList: null,
    activateProduct: null,
    productInfo: null,
    accountReports:null,
    modifierList:null,
    modifierTypeList:null,
    changeNomenclatureList:null,
    searchClientList:null,
    cardHistory:null,
    calcChangeNomenclature:null,
    contractList:null,
    pfile:null,
    client_file:null,
    productHistory:null
}

export const mutationTypes = {
    getClientAllListStart: '[clientAllList] Get client all list start',
    getClientAllListSuccess: '[clientAllList] Get client all list success',
    getClientAllListFailure: '[clientAllList] Get client all list failure',

    getClientListStart: '[clientList] Get client list start',
    getClientListSuccess: '[clientList] Get client list success',
    getClientListFailure: '[clientList] Get client list failure',

    getCardClientStart: '[cardClient] Get card client start',
    getCardClientSuccess: '[cardClient] Get card client success',
    getCardClientFailure: '[cardClient] Get card client failure',

    createClientStart: '[client] Create client start',
    createClientSuccess: '[client] Create client success',
    createClientFailure: '[client] Create client failure',

    searchClientStart: '[client] Search client by id start',
    searchClientSuccess: '[client] Search client by id success',
    searchClientFailure: '[client] Search client by id failure',

    updateClientStart: '[client] Update client start',
    updateClientSuccess: '[client] Update client success',
    updateClientFailure: '[client] Update client failure',

    cardInfoStart: '[card] Card info start',
    cardInfoSuccess: '[card] Card info success',
    cardInfoFailure: '[card] Card info failure',

    cardAddStart: '[card] Card add start',
    cardAddSuccess: '[card] Card add success',
    cardAddFailure: '[card] Card add failure',

    cardEditStart: '[card] Card edit start',
    cardEditSuccess: '[card] Card edit success',
    cardEditFailure: '[card] Card edit failure',

    cardUnlockStart: '[card] Card unlock start',
    cardUnlockSuccess: '[card] Card unlock success',
    cardUnlockFailure: '[card] Card unlock failure',

    cardBlockStart: '[card] Card block start',
    cardBlockSuccess: '[card] Card block success',
    cardBlockFailure: '[card] Card block failure',

    cardDeleteStart: '[card] Card delete start',
    cardDeleteSuccess: '[card] Card delete success',
    cardDeleteFailure: '[card] Card delete failure',

    changeClientStatusStart: '[clientStatus] Client change status start',
    changeClientStatusSuccess: '[clientStatus] Client change status  success',
    changeClientStatusFailure: '[clientStatus] Client change status  failure',

    getStatusListStart: '[statusList] Get status list start',
    getStatusListSuccess: '[statusList] Get status list success',
    getStatusListFailure: '[statusList] Get status list failure',

    getFreezeListStart: '[freezeList] Get freeze list start',
    getFreezeListSuccess: '[freezeList] Get freeze list success',
    getFreezeListFailure: '[freezeList] Get freeze list failure',

    setFreezeStatusStart: '[freezeList] Set freeze status start',
    setFreezeStatusSuccess: '[freezeList] Set freeze status success',
    setFreezeStatusFailure: '[freezeList] Set freeze status failure',

    setUnFreezeStatusStart: '[unfreezeList] Set unfreeze status start',
    setUnFreezeStatusSuccess: '[unfreezeList] Set unfreeze status success',
    setUnFreezeStatusFailure: '[unfreezeList] Set unfreeze status failure',

    setChangeOwnerStart: '[changeOwner] Change owner status start',
    setChangeOwnerSuccess: '[changeOwner] Change owner status success',
    setChangeOwnerFailure: '[changeOwner] Change owner status failure',

    getPacksStart: '[packs] Get packs start',
    getPacksSuccess: '[packs] Get packs success',
    getPacksFailure: '[packs] Get packs failure',

    getBuyListStart: '[getBuyList] Get buy list start',
    getBuyListSuccess: '[getBuyList] Get  buy list success',
    getBuyListFailure: '[getBuyList] Get  buy list failure',

    getMembershipStart: '[membership] Get membership start',
    getMembershipSuccess: '[membership] Get membership success',
    getMembershipFailure: '[membership] Get membership failure',

    getScheduleStart: '[schedule] Get schedule start',
    getScheduleSuccess: '[schedule] Get schedule success',
    getScheduleFailure: '[schedule] Get schedule failure',

    activateProductStart: '[activateProduct] Activate product start',
    activateProductSuccess: '[activateProduct] Activate product success',
    activateProductFailure: '[activateProduct] Activate product failure',

    clientProductInfoStart: '[productInfo] Product info start',
    clientProductInfoSuccess: '[productInfo] Product info success',
    clientProductInfoFailure: '[productInfo] Product info failure',

    getAccountReportStart: '[accountReport] Account Report start',
    getAccountReportSuccess: '[accountReport] Account Report success',
    getAccountReportFailure: '[accountReport] Account Report failure',

    getModifierListStart: '[modifierList] Modifier List start',
    getModifierListSuccess: '[modifierList] Modifier List success',
    getModifierListFailure: '[modifierList] Modifier List failure',

    getModifierTypeListStart: '[modifierTypeList] Modifier Type List start',
    getModifierTypeListSuccess: '[modifierTypeList] Modifier Type List success',
    getModifierTypeListFailure: '[modifierTypeList] Modifier Type List failure',

    changeNomenclatureStart: '[changeNomenclature] Change nomenclature start',
    changeNomenclatureSuccess: '[changeNomenclature] Change nomenclature success',
    changeNomenclatureFailure: '[changeNomenclature] Change nomenclature failure',

    changeNomenclatureListStart: '[changeNomenclatureList] Change nomenclature list start',
    changeNomenclatureListSuccess: '[changeNomenclatureList] Change nomenclature list success',
    changeNomenclatureListFailure: '[changeNomenclatureList] Change nomenclature list failure',

    saveSearchClientStart: '[saveSearchClient] Save search client start',
    saveSearchClientSuccess: '[saveSearchClient] Save search client success',
    saveSearchClientFailure: '[saveSearchClient] Save search client failure',

    getSearchClientStart: '[getSearchClient] Get search client start',
    getSearchClientSuccess: '[getSearchClient] Get search client success',
    getSearchClientFailure: '[getSearchClient] Get search client failure',

    getCardHistoryStart: '[getCardHistory] Get card history start',
    getCardHistorySuccess: '[getCardHistory] Get card history success',
    getCardHistoryFailure: '[getCardHistory] Get card history failure',
    
    setChangeTimeStart: '[setChangeTime] Set Change Time start',
    setChangeTimeSuccess: '[setChangeTime] Set Change Time success',
    setChangeTimeFailure: '[setChangeTime] Set Change Time failure',

    calcChangeNomenclatureStart: '[calcChangeNomenclature] Calc Change nomenclature start',
    calcChangeNomenclatureSuccess: '[calcChangeNomenclature] Calc Change nomenclature success',
    calcChangeNomenclatureFailure: '[calcChangeNomenclature] Calc Change nomenclature failure',

    getContractListStart: '[contractList] get Contract List',
    getContractListSuccess: '[contractList] get Contract List',
    getContractListFailure: '[contractList] get Contract List',

    printFileStart: '[pfile] print file',
    printFileSuccess: '[pfile] print file',
    printFileFailure: '[pfile] print file',

    saveClientFileStart: '[client_file] Save Client file',
    saveClientFileSuccess: '[client_file] Save Client file',
    saveClientFileFailure: '[client_file] Save Client file',

    getProductHistoryStart: '[getProductHistory] Get product history start',
    getProductHistorySuccess: '[getProductHistory] Get product history success',
    getProductHistoryFailure: '[getProductHistory] Get product history failure',
    
}

export const clientActionTypes = {
    getClientAllList: '[customClient] Get client all list',
    getClientList: '[customClient] Get client list',
    getCardClient: '[cardClient] Get card client',
    createClient: '[client] Create client',
    searchClient: '[client] Search client',
    updateClient: '[client] Update client',
    cardInfo: '[card] Card info',
    cardAdd: '[card] Card add',
    cardEdit: '[card] Card edit',
    cardUnlock: '[card] Card unlock',
    cardBlock: '[card] Card block',
    cardDelete: '[card] Card delete',
    changeClientStatus:'[clientStatus] Client change status',
    getStatusList: '[statusList] Get status list',
    getFreezeList: '[freezeList] Get freeze list',
    setFreezeStatus: '[freezeList] Set freeze status',
    setUnFreezeStatus: '[unfreezeList] Set unfreeze status',
    setChangeOwner: '[сhangeOwner] Set unfreeze status',
    getPacks: '[packs] Get packs data',
    getMembership: '[membership] Get membership data',
    getBuyList: '[buyList] Get buy data',
    getScheduleList: '[schedule] Get schedule data',
    activateProduct: '[activateProduct] Activate product',
    clientProductInfo: '[productInfo] Product info',
    getAccountReport: '[accountReport] Account Report',
    getModifierList: '[modifierList] Modifier List',
    getModifierTypeList: '[modifieTypeList] Modifier Type List',
    changeNomenclature: '[changeNomenclature] Change nomenclature',
    changeNomenclatureList: '[changeNomenclatureList] Change nomenclature List',
    saveSearchClient: '[saveSearchClient] Save search client',
    getSearchClient: '[getSearchClient] Get search client',
    getCardHistory: '[getCardHistory] Get card history',
    setChangeTime: '[changeTime] Set change time',
    calcChangeNomenclature: '[calcChangeNomenclature] Caclc Change nomenclature',
    getContractList: '[contractList] get Contract List',
    printFile: '[pfile] print file',
    saveClientFile: '[client_file] Save Client file',
    getProductHistory: '[getProductHistory] Get product history'
}

const mutations = {
    [mutationTypes.getClientAllListStart](state) {
        state.isLoading = true
        state.listAllClient = null
    },
    [mutationTypes.getClientAllListSuccess](state, payload) {
        state.isLoading = false
        state.listAllClient = payload
        state.validationErrors = null
    },
    [mutationTypes.getClientAllListFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.getClientListStart](state) {
        state.isLoading = true
        state.listClient = null
    },
    [mutationTypes.getClientListSuccess](state, payload) {
        state.isLoading = false
        state.listClient = payload
        state.validationErrors = null
    },
    [mutationTypes.getClientListFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.getCardClientStart](state) {
        state.isLoading = true
        state.client = null
    },
    [mutationTypes.getCardClientSuccess](state, payload) {
        state.isLoading = false
        state.client = payload
        state.validationErrors = null
    },
    [mutationTypes.getCardClientFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.createClientStart](state) {
        state.isLoading = true
        state.clientCreated = null
    },
    [mutationTypes.createClientSuccess](state, payload) {
        state.isLoading = false
        state.clientCreated = payload
        state.validationErrors = null
    },
    [mutationTypes.createClientFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.searchClientStart](state) {
        state.isLoading = true
        state.listClient = null
    },
    [mutationTypes.searchClientSuccess](state, payload) {
        state.isLoading = false
        state.listClient = payload
        state.validationErrors = null
    },
    [mutationTypes.searchClientFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.updateClientStart](state) {
        state.isLoading = true
        state.clientUpdated = null
    },
    [mutationTypes.updateClientSuccess](state, payload) {
        state.isLoading = false
        state.clientUpdated = payload
        state.validationErrors = null
    },
    [mutationTypes.updateClientFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.cardInfoStart](state) {
        state.isLoading = true
        state.card = null
    },
    [mutationTypes.cardInfoSuccess](state, payload) {
        state.isLoading = false
        state.card = payload
        state.validationErrors = null
    },
    [mutationTypes.cardInfoFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.cardAddStart](state) {
        state.isLoading = true
        state.cardCreated = null
    },
    [mutationTypes.cardAddSuccess](state, payload) {
        state.isLoading = false
        state.cardCreated = payload
        state.validationErrors = null
    },
    [mutationTypes.cardAddFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.cardEditStart](state) {
        state.isLoading = true
        state.cardUpdated = null
    },
    [mutationTypes.cardEditSuccess](state, payload) {
        state.isLoading = false
        state.cardUpdated = payload
        state.validationErrors = null
    },
    [mutationTypes.cardEditFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.cardUnlockStart](state) {
        state.isLoading = true
        state.cardUnlocked = null
    },
    [mutationTypes.cardUnlockSuccess](state, payload) {
        state.isLoading = false
        state.cardUnlocked = payload
        state.validationErrors = null
    },
    [mutationTypes.cardUnlockFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.cardBlockStart](state) {
        state.isLoading = true
        state.cardBlocked = null
    },
    [mutationTypes.cardBlockSuccess](state, payload) {
        state.isLoading = false
        state.cardBlocked = payload
        state.validationErrors = null
    },
    [mutationTypes.cardBlockFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.cardDeleteStart](state) {
        state.isLoading = true
        state.cardDeleted = null
    },
    [mutationTypes.cardDeleteSuccess](state, payload) {
        state.isLoading = false
        state.cardDeleted = payload
        state.validationErrors = null
    },
    [mutationTypes.cardDeleteFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.changeClientStatusStart](state) {
        state.isLoading = true
        state.data = null
    },
    [mutationTypes.changeClientStatusSuccess](state, payload) {
        state.isLoading = false
        state.data = payload
        state.validationErrors = null
    },
    [mutationTypes.changeClientStatusFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.getStatusListStart](state) {
        state.isLoading = true
        state.listStatus = null
    },
    [mutationTypes.getStatusListSuccess](state, payload) {
        state.isLoading = false
        state.listStatus = payload
        state.validationErrors = null
    },
    [mutationTypes.getStatusListFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },


    [mutationTypes.getFreezeListStart](state) {
        state.isLoading = true
        state.freezeList = null
    },
    [mutationTypes.getFreezeListSuccess](state, payload) {
        state.isLoading = false
        state.freezeList = payload
        state.validationErrors = null
    },
    [mutationTypes.getFreezeListFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
        state.freezeList = null
    },

    [mutationTypes.setFreezeStatusStart](state) {
        state.isLoading = true
        state.data = null
    },
    [mutationTypes.setFreezeStatusSuccess](state, payload) {
        state.isLoading = false
        state.data = payload
        state.validationErrors = null
    },
    [mutationTypes.setFreezeStatusFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
        state.data = null
    },


    [mutationTypes.setUnFreezeStatusStart](state) {
        state.isLoading = true
        state.data = null
    },
    [mutationTypes.setUnFreezeStatusSuccess](state, payload) {
        state.isLoading = false
        state.data = payload
        state.validationErrors = null
    },
    [mutationTypes.setUnFreezeStatusFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
        state.data = null
    },

    [mutationTypes.setChangeOwnerStart](state) {
        state.isLoading = true
        state.data = null
    },
    [mutationTypes.setChangeOwnerSuccess](state, payload) {
        state.isLoading = false
        state.data = payload
        state.validationErrors = null
    },
    [mutationTypes.setChangeOwnerFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
        state.data = null
    },

    [mutationTypes.getPacksStart](state) {
        state.isLoading = true
        state.packList = null
    },
    [mutationTypes.getPacksSuccess](state, payload) {
        state.isLoading = false
        state.packList = payload
        state.validationErrors = null
    },
    [mutationTypes.getPacksFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
        state.packList = null
    },


    [mutationTypes.getMembershipStart](state) {
        state.isLoading = true
        state.membershipList = null
    },
    [mutationTypes.getMembershipSuccess](state, payload) {
        state.isLoading = false
        state.membershipList = payload
        state.validationErrors = null
    },
    [mutationTypes.getMembershipFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
        state.membershipList = null
    },

    [mutationTypes.getBuyListStart](state) {
        state.isLoading = true
        state.buyList = null
    },
    [mutationTypes.getBuyListSuccess](state, payload) {
        state.isLoading = false
        state.buyList = payload
        state.validationErrors = null
    },
    [mutationTypes.getBuyListFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
        state.buyList = null
    },


    [mutationTypes.getScheduleStart](state) {
        state.isLoading = true
        state.scheduleList = null
    },
    [mutationTypes.getScheduleSuccess](state, payload) {
        state.isLoading = false
        state.scheduleList = payload
        state.validationErrors = null
    },
    [mutationTypes.getScheduleFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
        state.scheduleList = null
    },

    [mutationTypes.activateProductStart](state) {
        state.isLoading = true
        state.activateProduct = null
    },
    [mutationTypes.activateProductSuccess](state, payload) {
        state.isLoading = false
        state.activateProduct = payload
        state.validationErrors = null
    },
    [mutationTypes.activateProductFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.clientProductInfoStart](state) {
        state.isLoading = true
        state.productInfo = null
    },
    [mutationTypes.clientProductInfoSuccess](state, payload) {
        state.isLoading = false
        state.productInfo = payload
        state.validationErrors = null
    },
    [mutationTypes.clientProductInfoFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.getAccountReportStart](state) {
        state.isLoading = true
        state.accountReports = null
    },
    [mutationTypes.getAccountReportSuccess](state, payload) {
        state.isLoading = false
        state.accountReports = payload
        state.validationErrors = null
    },
    [mutationTypes.getAccountReportFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.getModifierListStart](state) {
        state.isLoading = true
        state.modifierList = null
    },
    [mutationTypes.getModifierListSuccess](state, payload) {
        state.isLoading = false
        state.modifierList = payload
        state.validationErrors = null
    },
    [mutationTypes.getModifierListFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.getModifierTypeListStart](state) {
        state.isLoading = true
        state.modifierTypeList = null
    },
    [mutationTypes.getModifierTypeListSuccess](state, payload) {
        state.isLoading = false
        state.modifierTypeList = payload
        state.validationErrors = null
    },
    [mutationTypes.getModifierTypeListFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.changeNomenclatureStart](state) {
        state.isLoading = true
        state.data = null
    },
    [mutationTypes.changeNomenclatureSuccess](state, payload) {
        state.isLoading = false
        state.data = payload
        state.validationErrors = null
    },
    [mutationTypes.changeNomenclatureFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
        state.data = null
    },

    [mutationTypes.changeNomenclatureListStart](state) {
        state.isLoading = true
        state.changeNomenclatureList = null
    },
    [mutationTypes.changeNomenclatureListSuccess](state, payload) {
        state.isLoading = false
        state.changeNomenclatureList = payload
        state.validationErrors = null
    },
    [mutationTypes.changeNomenclatureListFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.saveSearchClientStart](state) {
        state.isLoading = true
        state.data = null
    },
    [mutationTypes.saveSearchClientSuccess](state, payload) {
        state.isLoading = false
        state.data = payload
        state.validationErrors = null
    },
    [mutationTypes.saveSearchClientFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.getSearchClientStart](state) {
        state.isLoadingS = true
        state.searchClientList = null
    },
    [mutationTypes.getSearchClientSuccess](state, payload) {
        state.isLoadingS = false
        state.searchClientList = payload
        state.validationErrors = null
    },
    [mutationTypes.getSearchClientFailure](state,payload) {
        state.isLoadingS = false
        state.validationErrors = payload
    },

    [mutationTypes.getCardHistoryStart](state) {
        state.isLoadingS = true
        state.cardHistory = null
    },
    [mutationTypes.getCardHistorySuccess](state, payload) {
        state.isLoadingS = false
        state.cardHistory = payload
        state.validationErrors = null
    },
    [mutationTypes.getCardHistoryFailure](state,payload) {
        state.isLoadingS = false
        state.validationErrors = payload
    },

    [mutationTypes.setChangeTimetart](state) {
        state.isLoading = true
        state.data = null
    },
    [mutationTypes.setChangeTimeSuccess](state, payload) {
        state.isLoading = false
        state.data = payload
        state.validationErrors = null
    },
    [mutationTypes.setChangeTimeFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
        state.data = null
    },

    [mutationTypes.calcChangeNomenclatureStart](state) {
        state.isLoading = true
        state.calcChangeNomenclature = null
    },
    [mutationTypes.calcChangeNomenclatureSuccess](state, payload) {
        state.isLoading = false
        state.calcChangeNomenclature = payload
        state.validationErrors = null
    },
    [mutationTypes.calcChangeNomenclatureFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
        state.data = null
    },

    [mutationTypes.getContractListStart](state) {
        state.isLoading = true
        state.contractList = null
    },
    [mutationTypes.getContractListSuccess](state, payload) {
        state.isLoading = false
        state.contractList = payload
        state.validationErrors = null
    },
    [mutationTypes.getContractListFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
        state.contractList = null
    },

    [mutationTypes.printFileStart](state) {
        state.isLoading = true
        state.pfile = null
    },
    [mutationTypes.printFileSuccess](state, payload) {
        state.isLoading = false
        state.pfile = payload
        state.validationErrors = null
    },
    [mutationTypes.printFileFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
        state.pfile = null
    },

    [mutationTypes.saveClientFileStart](state) {
        state.isLoading = true
        state.client_file = null
    },
    [mutationTypes.saveClientFileSuccess](state, payload) {
        state.isLoading = false
        state.client_file = payload
        state.validationErrors = null
    },
    [mutationTypes.saveClientFileFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
        state.client_file = null
    },
    
    [mutationTypes.getProductHistoryStart](state) {
        state.isLoading = true
        state.productHistory = null
    },
    [mutationTypes.getProductHistorySuccess](state, payload) {
        state.isLoading = false
        state.productHistory = payload
        state.validationErrors = null
    },
    [mutationTypes.getProductHistoryFailure](state,payload) {
        state.isLoadingS = false
        state.validationErrors = payload
    },
}

const actions = {
    [clientActionTypes.getClientAllList](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getClientAllListStart)
            clientApi
                .getClientAllList(data)
                .then(response => {
                    context.commit(mutationTypes.getClientAllListSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getClientAllListFailure,response)
                })
        })
    },
    [clientActionTypes.getClientList](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getClientListStart)
            clientApi
                .getClientList(data)
                .then(response => {
                    context.commit(mutationTypes.getClientListSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getClientListFailure,response)
                })
        })
    },
    [clientActionTypes.getCardClient](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getCardClientStart)
            clientApi
                .getCardClient(data)
                .then(response => {
                    context.commit(mutationTypes.getCardClientSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getCardClientFailure,response)
                })
        })
    },
    [clientActionTypes.createClient](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.createClientStart)
            clientApi
                .createClient(data)
                .then(response => {
                    context.commit(mutationTypes.createClientSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.createClientFailure,response)
                })
        })
    },
    [clientActionTypes.searchClient](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.searchClientStart)
            clientApi
                .searchClient(data)
                .then(response => {
                    context.commit(mutationTypes.searchClientSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.searchClientFailure, response)
                })
        })
    },
    [clientActionTypes.updateClient](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.updateClientStart)
            clientApi
                .updateClient(data)
                .then(response => {
                    context.commit(mutationTypes.updateClientSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.updateClientFailure,response)
                })
        })
    },
    [clientActionTypes.cardInfo](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.cardInfoStart)
            clientApi
                .cardInfo(data)
                .then(response => {
                    context.commit(mutationTypes.cardInfoSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.cardInfoFailure,response)
                })
        })
    },
    [clientActionTypes.cardAdd](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.cardAddStart)
            clientApi
                .cardAdd(data)
                .then(response => {
                    context.commit(mutationTypes.cardAddSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.cardAddFailure,response)
                })
        })
    },
    [clientActionTypes.cardEdit](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.cardEditStart)
            clientApi
                .cardEdit(data)
                .then(response => {
                    context.commit(mutationTypes.cardEditSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.cardEditFailure,response)
                })
        })
    },
    [clientActionTypes.cardUnlock](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.cardUnlockStart)
            clientApi
                .cardUnlock(data)
                .then(response => {
                    context.commit(mutationTypes.cardUnlockSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.cardUnlockFailure,response)
                })
        })
    },
    [clientActionTypes.cardBlock](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.cardBlockStart)
            clientApi
                .cardBlock(data)
                .then(response => {
                    context.commit(mutationTypes.cardBlockSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.cardBlockFailure,response)
                })
        })
    },
    [clientActionTypes.cardDelete](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.cardDeleteStart)
            clientApi
                .cardDelete(data)
                .then(response => {
                    context.commit(mutationTypes.cardDeleteSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.cardDeleteFailure,response)
                })
        })
    },
    [clientActionTypes.changeClientStatus](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.changeClientStatusStart)
            clientApi
                .changeStatusPresence(data)
                .then(response => {
                    context.commit(mutationTypes.changeClientStatusSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.changeClientStatusFailure,response)
                })
        })
    },
    [clientActionTypes.getStatusList](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getStatusListStart)
            clientApi
                .getStatusList(data)
                .then(response => {
                    context.commit(mutationTypes.getStatusListSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getStatusListFailure,response)
                })
        })
    },
    [clientActionTypes.getFreezeList](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getFreezeListStart)
            clientApi
                .getClientFreezeList(data)
                .then(response => {
                    context.commit(mutationTypes.getFreezeListSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getFreezeListFailure,response)
                })
        })
    },
    [clientActionTypes.setFreezeStatus](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.setFreezeStatusStart)
            clientApi
                .setClientFreezeStatus(data)
                .then(response => {
                    context.commit(mutationTypes.setFreezeStatusSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.setFreezeStatusFailure,response)
                })
        })
    },
    [clientActionTypes.setUnFreezeStatus](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.setUnFreezeStatusStart)
            clientApi
                .setClientUnFreezeStatus(data)
                .then(response => {
                    context.commit(mutationTypes.setUnFreezeStatusSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.setUnFreezeStatusFailure,response)
                })
        })
    },

    [clientActionTypes.setChangeOwner](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.setChangeOwnerStart)
            clientApi
                .setClientChangeOwner(data)
                .then(response => {
                    context.commit(mutationTypes.setChangeOwnerSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.setChangeOwnerFailure,response)
                })
        })
    },

    [clientActionTypes.getPacks](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getPacksStart)
            clientApi
                .clientPacks(data)
                .then(response => {
                    context.commit(mutationTypes.getPacksSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getPacksFailure,response)
                })
        })
    },

    [clientActionTypes.getMembership](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getMembershipStart)
            clientApi
                .clientMembership(data)
                .then(response => {
                    context.commit(mutationTypes.getMembershipSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getMembershipFailure,response)
                })
        })
    },

    [clientActionTypes.getBuyList](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getBuyListStart)
            clientApi
                .clientBuyList(data)
                .then(response => {
                    context.commit(mutationTypes.getBuyListSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getBuyListFailure,response)
                })
        })
    },

    [clientActionTypes.getScheduleList](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getScheduleStart)
            clientApi
                .clientScheduleList(data)
                .then(response => {
                    context.commit(mutationTypes.getScheduleSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getScheduleFailure,response)
                })
        })
    },

    [clientActionTypes.activateProduct](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.activateProductStart)
            clientApi
                .clientActivateProduct(data)
                .then(response => {
                    context.commit(mutationTypes.activateProductSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.activateProductFailure,response)
                })
        })
    },

    [clientActionTypes.clientProductInfo](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.clientProductInfoStart)
            clientApi
                .clientProductInfo(data)
                .then(response => {
                    context.commit(mutationTypes.clientProductInfoSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.clientProductInfoFailure,response)
                })
        })
    },

    [clientActionTypes.getAccountReport](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getAccountReportStart)
            clientApi
                .getAccountReport(data)
                .then(response => {
                    context.commit(mutationTypes.getAccountReportSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getAccountReportFailure,response)
                })
        })
    },

    [clientActionTypes.getModifierList](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getModifierListStart)
            clientApi
                .getModifierList(data)
                .then(response => {
                    context.commit(mutationTypes.getModifierListSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getModifierListFailure,response)
                })
        })
    },

    [clientActionTypes.getModifierTypeList](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getModifierTypeListStart)
            clientApi
                .getModifierTypeList(data)
                .then(response => {
                    context.commit(mutationTypes.getModifierTypeListSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getModifierTypeListFailure,response)
                })
        })
    },

    [clientActionTypes.changeNomenclature](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.changeNomenclatureStart)
            clientApi
                .changeNomenclature(data)
                .then(response => {
                    context.commit(mutationTypes.changeNomenclatureSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.changeNomenclatureFailure,response)
                })
        })
    },

    [clientActionTypes.changeNomenclatureList](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.changeNomenclatureListStart)
            clientApi
                .changeNomenclatureList(data)
                .then(response => {
                    context.commit(mutationTypes.changeNomenclatureListSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.changeNomenclatureListFailure,response)
                })
        })
    },
    
    [clientActionTypes.saveSearchClient](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.saveSearchClientStart)
            clientApi
                .saveSearchClient(data)
                .then(response => {
                    context.commit(mutationTypes.saveSearchClientSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.saveSearchClientFailure,response)
                })
        })
    },

    [clientActionTypes.getSearchClient](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getSearchClientStart)
            clientApi
                .getSearchClient(data)
                .then(response => {
                    context.commit(mutationTypes.getSearchClientSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getSearchClientFailure,response)
                })
        })
    },

    [clientActionTypes.getCardHistory](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getCardHistoryStart)
            clientApi
                .getCardHistory(data)
                .then(response => {
                    context.commit(mutationTypes.getCardHistorySuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getCardHistoryFailure,response)
                })
        })
    },
    
    [clientActionTypes.setChangeTime](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.setChangeTimeStart)
            clientApi
                .setChangeTime(data)
                .then(response => {
                    context.commit(mutationTypes.setChangeTimeSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.setChangeTimeFailure,response)
                })
        })
    },

    [clientActionTypes.calcChangeNomenclature](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.calcChangeNomenclatureStart)
            clientApi
                .calcChangeNomenclature(data)
                .then(response => {
                    context.commit(mutationTypes.calcChangeNomenclatureSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.calcChangeNomenclatureFailure,response)
                })
        })
    },

    [clientActionTypes.getContractList](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getContractListStart)
            clientApi
                .getContractList(data)
                .then(response => {
                    context.commit(mutationTypes.getContractListSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getContractListFailure,response)
                })
        })
    },

    [clientActionTypes.printFile](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.printFileStart)
            clientApi
                .printFile(data)
                .then(response => {
                    context.commit(mutationTypes.printFileSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.printFileFailure,response)
                })
        })
    },

    [clientActionTypes.saveClientFile](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.saveClientFileStart)
            clientApi
                .saveClientFile(data)
                .then(response => {
                    context.commit(mutationTypes.saveClientFileSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.saveClientFileFailure,response)
                })
        })
    },

    [clientActionTypes.getProductHistory](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getProductHistoryStart)
            clientApi
                .getProductHistory(data)
                .then(response => {
                    context.commit(mutationTypes.getProductHistorySuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getProductHistoryFailure,response)
                })
        })
    },
    
}

export default {
    state,
    actions,
    mutations
}